import React from 'react';
import PropTypes from 'prop-types';
import RequestSent from './RequestSent';
import Modal from './Modal';
import './ForgotPasswordModal.scss';

export default function RequestSentModal(props) {
  const { isOpen, isLoading, onRequestClose } = props;
  const isCloseable = true;
  
  // Ensure we have a valid function
  const handleRequestClose = isCloseable ? onRequestClose : () => {};

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={handleRequestClose}
      className="forgot-password-modal"
      showCloseButton={!isLoading}
    >
      <RequestSent {...props} />
    </Modal>
  );
}

RequestSentModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  // Removed ...RequestSent.PropTypes to avoid 'undefined' property access
};
